import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FoodcourtService {

  private dataSubject = new BehaviorSubject<string>('Initial data');
  public data$ = this.dataSubject.asObservable();
  excelContent: any;

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) { }

  sendData(data: string) {
    this.dataSubject.next(data);
  }

  setExcelData(data) {
    this.excelContent = data;
  }

  getExcelData() {
    return this.excelContent
  }

  getParkByCLAId() {
    return this.apiService.get(`${APIs.getParkByClaId}?claId=${localStorage.getItem('claAdminId')}`).pipe(map(response => {
      if (response.isValid) {
        // this.parkDropDownDetails.next(response.list);
        console.log(response.list);
      }
      return response;
    }))
  }

  getAllVendorList(): Observable<any> {
    // let parkId = localStorage.getItem('parkId');
    let foodCourtId = localStorage.getItem('food_court_id');
    // let foodCourtId = '7610766a-c4b3-4484-8c65-b66662aae77c';
    return this.apiService.get(APIs.gelAllVendorByPark + '/' + foodCourtId).pipe(map(response => {
      // return response?.list;
      return response;
    }));
  }

  getSurveyDetails(id: string): Observable<any> {
    return this.apiService.get(APIs.getSingleSurveyDetails + '?surveyId=' + id).pipe(map(response => {
      return response;
    }));
  }

  removeVendor(body: any): Observable<any> {
    return this.apiService.post(APIs.removeVendor, body).pipe(map(response => {
      return response;
    }));
  }

  removeVendorBulk(body: any): Observable<any> {
    return this.apiService.post(APIs.removeVendorBulk, body).pipe(map(response => {
      return response;
    }));
  }

  getVendorDetails(id: string): Observable<any> {
    return this.apiService.get(APIs.getVendorDetails + '/' + id).pipe(map(response => {
      return response;
    }));
  }

  updateMarkAsClosedOpened(data): Observable<any> {
    return this.apiService.post(APIs.foodVendorMarkedClosed, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getVendorReviewList(id: string): Observable<any> {
    return this.apiService.get(APIs.vendorReviewList + '/' + id).pipe(map(response => {
      return response;
    }));
  }

  vendorReviewFilterData(id: string, searchText: string): Observable<any> {
    return this.apiService.get(APIs.filterVendorReview + '?foodCourtVendorId=' + id + '&searchText=' + searchText).pipe(map(response => {
      return response;
    }));
  }

  removeFlagBulk(body: any): Observable<any> {
    return this.apiService.post(APIs.bulkVendorRemoveFlag, body).pipe(map(response => {
      return response;
    }));
  }

  hideBulkReview(body: any): Observable<any> {
    return this.apiService.post(APIs.bulkVendorHideReview, body).pipe(map(response => {
      return response;
    }));
  }

  hideSingleReview(body: any): Observable<any> {
    return this.apiService.post(APIs.singleVendorHideReview, body).pipe(map(response => {
      return response;
    }));
  }

  unHideBulkReview(body: any): Observable<any> {
    return this.apiService.post(APIs.bulkVendorUnHideReview, body).pipe(map(response => {
      return response;
    }));
  }

  mainFoodCourtList(): Observable<any> {
    let parkId = localStorage.getItem('parkId');
    return this.apiService.get(APIs.listFoodCourt + '/' + parkId).pipe(map(response => {
      return response;
    }));
  }

  addFoodCourt(body?: any): Observable<any> {
    return this.apiService.post(APIs.createFoodCourt, body).pipe(map(response => {
      return response;
    }));
  }

  updateFoodCort(body?: any): Observable<any> {
    return this.apiService.post(APIs.updateFoodCourt, body).pipe(map(response => {
      return response;
    }));
  }

  removeBulkFoodCourt(body: any): Observable<any> {
    return this.apiService.post(APIs.bulkRemoveFoodCourt, body).pipe(map(response => {
      return response;
    }));
  }
}
